import React from "react"
import { Address } from "../generated/graphql"

export const ClientDetailsAddress = ({
  address,
}: {
  address: Pick<
    Address,
    | "label"
    | "plain"
    | "contactName"
    | "contactPhone"
    | "contactEmail"
    | "addressType"
    | "deliveryAppointmentRequired"
    | "dock"
    | "warehouseAddressNotes"
  >
}) => (
  <div>
    {address.label && <p className="font-weight-bold mb-0">{address.label}</p>}
    {address.plain.split("\n").map((line, i) => (
      <p key={i} className="mb-0">
        {line}
      </p>
    ))}
    {address.contactName && (
      <p className="mb-0">Contact: {address.contactName}</p>
    )}
    {address.contactPhone && (
      <p className="mb-0">Phone: {address.contactPhone}</p>
    )}
    {address.contactEmail && (
      <p className="mb-0">Email: {address.contactEmail}</p>
    )}

    {address.addressType === "warehouse" && (
      <div className="warehouse-details mt-2">
        <p className="font-weight-bold mb-0">Warehouse Details</p>
        <p className="mb-0">
          {address.deliveryAppointmentRequired
            ? "Delivery appointment required"
            : "No delivery appointment required"}
        </p>
        <p className="mb-0">
          {address.dock ? "Dock available" : "No dock available"}
        </p>
        <div>
          <p className="mb-0">Unloading requirements:</p>
          <p className="mb-0 pl-2">
            {address.warehouseAddressNotes || "None specified"}
          </p>
        </div>
      </div>
    )}
  </div>
)
